<template>
    <div class="bindPhoneStep">
        <div class="group group-1"
             v-if="step === 1">
            <div class="item item-1">
                <label for="phoneNum"
                       class="label">手机号：</label>
                <input type="text"
                       maxlength="11"
                       id="phoneNum"
                       v-model="inputPhoneNum"
                       class="input inputPhoneNum"
                       placeholder="请输入您的手机号"
                       @keyup="fnCheckPhoneNum"
                       @keyup.enter="fnSendPhoneCode" />
            </div>
            <div class="item item-2">
                <a href="javascript:;"
                   class="btnNml btnSendPhoneCode"
                   @click="fnSendPhoneCode">发送验证短信</a>
            </div>
        </div>
        <div class="group group-2"
             v-if="step === 2">
            <div class="item item-3">
                验证码已发送至您的手机：
                <input type="text"
                       v-model="inputPhoneNum"
                       disabled
                       class="inputPhoneNumDisabled colorfd9d2b" />
            </div>
            <div class="item item-4">
                请将验证码写入下方输入框。没收到验证码？
                <a href="javascript:;"
                   @click="fnSendPhoneCode"
                   :class="{colorfd9d2b: reSend}">重新发送（<span v-text="countDownNum"></span>）</a>
            </div>
            <div class="item item-5">
                <label for="phoneCode"
                       class="label">验证码：</label>
                <input type="text"
                       maxlength="6"
                       id="phoneCode"
                       v-model="inputPhoneCode"
                       class="input inputPhoneCode"
                       placeholder="请输入短信验证码"
                       @keyup.enter="fnCheckPhoneCode" />
            </div>
            <div class="item item-6">
                <a href="javascript:;"
                   class="btnNml btnVerifyPhoneCode"
                   @click="fnCheckPhoneCode">下一步</a>
                <a href="javascript:;"
                   @click="fnBackEditPhoneNum"
                   style="margin-left:15px;">返回修改手机号</a>
            </div>
        </div>
        <div class="group group-3"
             v-if="step === 3">
            <div class="item item-7">
                <div class="top">
                    <div class="img">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="42px"
                             height="30px">
                            <path fill-rule="evenodd"
                                  fill="rgb(255, 255, 255)"
                                  d="M40.445,4.412 L15.443,29.413 C14.920,29.936 14.184,30.105 13.516,29.935 C12.870,30.096 12.161,29.931 11.656,29.426 L0.574,18.344 C-0.191,17.579 -0.191,16.338 0.574,15.573 C1.339,14.808 2.579,14.808 3.344,15.573 L13.456,25.686 L37.588,1.554 C38.377,0.765 39.656,0.765 40.445,1.554 C41.234,2.343 41.234,3.623 40.445,4.412 Z" />
                        </svg>
                    </div>
                    <div class="txt">
                        <p class="txt-1">恭喜您绑定成功</p>
                        <p class="txt-2">获得专属高额优惠券，请立即前往领取哦！</p>
                    </div>
                </div>
            </div>
            <div class="item item-8">
                <a href="javascript:;"
                   class="btnNml btnGetCoupon"
                   @click="step = 4">立即领取</a>
            </div>
        </div>
        <div class="group group-4"
             v-if="step === 4">
            <div class="item item-9">
                <div class="top">
                    <div class="txt">
                        <p class="title">恭喜您获绑定手机号专属高额优惠券</p>
                        <p>请前往<a href="javascript:;"
                               @click="openWeb">个人中心</a>查看</p>
                    </div>
                </div>
            </div>
            <div class="item item-10">
                <a href="javascript:;"
                   class="btnNml btnGetCoupon"
                   @click="openWeb">确定</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BindPhoneStep',
    data () {
        return {
            name: '绑定手机，输入手机号',
            inputPhoneNum: '',
            inputPhoneCode: '',
            step: 1,
            countDownNum: 60,
            reSend: true,
            btnFastClick: false,
            countDownTimer: null,
            captchaObj: null
        }
    },
    mounted () {
        this.fnInitGee()
    },
    methods: {
        // 下次再说
        fnExitClient () {
            this.$emit('fnBtnClick', 'exitClient')
        },
        // 初始化极验
        fnInitGee (captchaObj) {
            var t = this
            // eslint-disable-next-line
            ELSDK.SDKAPI('geeInit', {}, captchaObj => {
                this.captchaObj = captchaObj
                this.captchaObj.onSuccess(function () {
                    var result = t.captchaObj.getValidate()
                    if (!result) {
                    } else {
                        var geeData = {
                            gee_client_type: 'web',
                            gee_challenge: result.geetest_challenge,
                            gee_validate: result.geetest_validate,
                            gee_seccode: result.geetest_seccode
                        }
                        t.sendPhoneCode(geeData)
                    }
                })
            })
        },
        fnBackEditPhoneNum () {
            this.step = 1
            this.countDownNum = 60
            this.btnFastClick = false
            this.reSend = true
            clearInterval(this.countDownTimer)
        },
        sendPhoneCode (data) {
            let t = this
            let query = Object.assign(
                {
                    phone: this.inputPhoneNum
                },
                data
            )
            // eslint-disable-next-line
            ELSDK.SDKAPI("bindPhoneCode", query, (res) => {
                this.btnFastClick = false
                if (res.status === 'error') {
                    this.Toast({
                        content: res.msg
                    })
                    return
                }
                this.step = 2
                this.fnCountDown()
            })
        },
        // 倒计时
        fnCountDown () {
            this.reSend = false
            this.countDownTimer = setInterval(() => {
                this.countDownNum--
                if (this.countDownNum < 0) {
                    this.countDownNum = 0
                    clearInterval(this.countDownTimer)
                    this.reSend = true
                    this.countDownNum = 60
                }
            }, 1000)
        },
        // 验证输入的短信验证码
        fnCheckPhoneCode () {
            if (this.btnFastClick) return
            this.btnFastClick = true
            if (this.inputPhoneCode.length < 6) {
                this.Toast({
                    content: '验证码不能少于6位'
                })
                this.btnFastClick = false
                return
            }
            ELSDK.SDKAPI(
                'bindPhone',
                { phone: this.inputPhoneNum, code: this.inputPhoneCode },
                (res) => {
                    this.btnFastClick = false
                    if (res.status === 'error') {
                        this.Toast({
                            content: res.msg
                        })
                        return
                    }
                    this.step = 3
                })
        },
        openWeb () {
            this.fnCefGameBox({
                method: 'clientOpenBrowser',
                data: {
                    url: 'https://www.yilewan.com/my/coupon',
                    type: 0
                }
            })
            this.$emit('fnBtnClick', 'closeModal')
        },
        // 手机号验证
        fnCheckPhoneNum () {
            let phoneNum = Number(this.inputPhoneNum)
            // eslint-disable-next-line
            if (!(/^[\d\+\-\*\/\(\)]+$/.test(phoneNum))) {
                this.Toast({
                    content: '手机号码有误，请重新输入'
                })
            }
        },
        // 发送验证短信
        fnSendPhoneCode () {
            console.log(this.btnFastClick)
            if (this.btnFastClick || !this.reSend) return
            if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(Number(this.inputPhoneNum)))) {
                this.Toast({
                    content: '手机号码有误，请重新输入'
                })
                return
            }
            this.btnFastClick = true
            this.captchaObj.verify()
        },
    }
}
</script>

<style>
</style>
